import { Component, OnInit, AfterViewInit, Input, Output, ChangeDetectorRef, EventEmitter, trigger, transition, style, animate, state, keyframes, NgZone } from "@angular/core";
import { FetchDataService } from "Services/fetch-data.service";
import { CookieManagementService as CookieService } from "Services/cookie-management.service";
import { EventService } from "Services/event.service";
//import { AdalService } from "ng2-adal/dist/core";
import { Adal4Service as AdalService } from 'adal-angular4';
import { AppConfig } from "Classes/AppConfig";

declare var $: any;


@Component({
    selector: "navigation-bar",
    template: require('./navigation-bar.component.html'),
    styles: [require('./navigation-bar.component.css')],
    animations: [
        trigger(
            'open',
            [
                state('inactive', style({
                    transform: "translateY(-100%)"
                })),
                state('active', style({
                    transform: "translateY(0%)"
                })),
                transition('inactive => active', [
                    animate('400ms ease-in-out', keyframes([
                        style({ transform: "translateY(-100%)", offset: 0 }),
                        style({ transform: "translateY(3%)", offset: 0.7 }),
                        style({ transform: "translateY(0%)", offset: 1.0 })
                    ]))
                ]),
                transition('active => inactive', [
                    animate('400ms ease-in-out', keyframes([
                        style({ transform: "translateY(0%)", offset: 0 }),
                        style({ transform: "translateY(3%)", offset: 0.3 }),
                        style({ transform: "translateY(-100%)", offset: 1.0 }),
                    ]))
                ]),
            ]
        )
    ],
})

export class NavigationBarComponent implements OnInit, AfterViewInit {
    constructor(
        private fetchDataService: FetchDataService,
        private cookieService: CookieService,
        private ngZone: NgZone,
        private eventService: EventService,
        private adalService: AdalService,
        private changeDetectorRef: ChangeDetectorRef,
        private appConfig: AppConfig
    ) {

    }

    @Input() links: any[];
    @Input() headerText: string;
    @Input() menu: boolean;
    @Input() navOpened: string;
    @Output() navOpenedChange: EventEmitter<string> = new EventEmitter<string>();

    @Input() accountInfoTxt: string;
    permissionsManagementText: string = "Manage Permissions";
    userManagementTxt: string = "Create User";
    homeTxt: string = "Home";
    somewhereElseTxt: string = "Somewhere Else";
    signOutTxt: string = "Sign Out";

    opened: string = "inactive";
    _authData: any; 
    _userManagement: boolean = false;
    _accountInfo: boolean = false;

    ngOnInit(): void {
        if (this.navOpened)
            this.opened = this.navOpened;
        for (let link of this.links) {
            link._this = this;
        }
        this._authData = this.fetchDataService.getAuthData();

        //this._authData.permission = this.fetchDataService.getPermissions();

        let blah = 4;
    }

    ngAfterViewInit(): void {
    }

    handleLink(ref: NavigationBarComponent, text: string): void {
        switch (text) {
            case ref.accountInfoTxt: ref.openAccountInfoWindow(); break;
            case ref.userManagementTxt: ref.openUserManagementWindow(); break;
            case ref.permissionsManagementText: ref.openPermissionsManagementWindow(); break;
            case ref.homeTxt: ref.reloadPage(); break;
            case ref.signOutTxt: ref.signOut(); break;
            case ref.somewhereElseTxt: break;
        }
        //ref.changeDetectorRef.detectChanges();
        
    }

    openPermissionsManagementWindow(): void {
        this.eventService.broadcast(this.eventService._openUserManagement);
    }

    reloadPage(): void {
        //this.ngZone.runOutsideAngular(() => {
            window.location.reload();
        //});
    }

    async signOut() {
        //this.ngZone.runOutsideAngular(() => {
        this.removeAllDomainCookies();
            //Backup for cookieService failing
            //document.cookie = ";expires=Thu, 05 Oct 1990 00:00:01 GMT;";
    
            //window.location.reload();
        this.adalService.clearCacheForResource(this.appConfig.azureResourceId);
        let azureAccessToken: any;
        try
        {
            azureAccessToken = await this.adalService.acquireToken(this.appConfig.azureResourceId).toPromise();
        }
        catch (e) {
            console.error(e);

            if ((e as string).startsWith("AADSTS50058"))
            {
                this.adalService.logOut();
                return;
            }
            else
            {
                window.location.replace(process.env.PORTAL_URL);
            }
        }
        if (azureAccessToken)
            this.adalService.logOut();
        else
            window.location.replace(process.env.PORTAL_URL);
        //});
    }

    removeAllDomainCookies(): void {
        this.cookieService.removeAll();
    }

    openAccountInfoWindow(): void {
        this.eventService.broadcast(this.eventService._openAccountInfo);
    }

    openUserManagementWindow(): void {
        this.eventService.broadcast(this.eventService._openUserManagement);
    }

    toggle(): void {
        if (this.opened == "inactive")
            this.opened = "active";
        else
            this.opened = "inactive";
        if (this.navOpened)
            this.navOpenedChange.emit(this.opened);
        this.changeDetectorRef.detectChanges();

    }

    open(): void {
        this.opened = "active";
        if (this.navOpened)
            this.navOpenedChange.emit(this.opened);
        this.changeDetectorRef.detectChanges();

    }

    close(): void {
        this.opened = "inactive";
        if (this.navOpened)
            this.navOpenedChange.emit(this.opened);
        this.changeDetectorRef.detectChanges();

    }

    upperCase(str: string): string {
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }

    getName(): string {
        if (this._authData.firstName)
            if (this._authData.lastName)
                return this.upperCase(this._authData.firstName) + ' ' + this.upperCase(this._authData.lastName);
            else
                return this.upperCase(this._authData.firstName)
        else if (this._authData.user)
            return this._authData.user;
        else
            return "No username";
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./App/Components/navigation-bar.component.ts